<template>
  <div ref="app">
    <router-view :key="$route.query.t" />
  </div>
</template>

<script>
import { useIcCardLogin } from '@/hooks/useIcCardLogin'
import { usePackageUpdate } from '@/hooks/usePackageUpdate'
import { useAppEvent } from '@/hooks/useAppEvent'

export default {
  name: 'App',
  setup() {
    const { addReadIcCardCodeListener, removeReadIcCardCodeListener } = useIcCardLogin()
    onMounted(() => {
      addReadIcCardCodeListener()
    })
    onBeforeUnmount(() => {
      removeReadIcCardCodeListener()
    })

    // 检测更新
    usePackageUpdate()

    useAppEvent()
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.update-merchant-dialog {
  .el-dialog__header {
    padding: 40px 0 30px;
    text-align: center;
    margin-right: 0;
  }

  .el-dialog__body {
    padding: 0 40px 45px;

    .el-form-item {
      margin-bottom: 30px;
    }

    .form-btn-wrap {
      margin-top: 10px;

      .el-button {
        width: 148px;
        border-radius: 4px;

        .el-icon {
          display: none;
        }
      }
    }
  }
}
</style>
